<template>
  <div><el-empty description="敬请期待"></el-empty></div>
</template>

<script>
export default {

}
</script>

<style>

</style>